import { timeToMinutes } from "../../../../redux/curriculum/model";
import { ScheduleListState } from "../../../../redux/curriculum/scheduleListSlice";

export function calculateStartEnd(scheduleList: ScheduleListState) {
    let _start = 24 * 60;
    let _end = 0;

    (scheduleList.list || []).forEach((item) => {
        const start = timeToMinutes(item.startTime);
        const end = timeToMinutes(item.endTime);
        if (start < _start) {
            _start = start;
        }
        if (end > _end) {
            _end = end;
        }
    });

    if (_start == 24 * 60) {
        _start = 0;
    }
    if (_end == 0) {
        _end = 24 * 60;
    }

    return [_start, _end];
}
